export enum ClaimStatus {
  Unclaimed = "Unclaimed",
  Claimed = "Claimed",
  ClaimedByYou = "ClaimedByYou"
}
